<template>
  <div style="padding: 10px">
    <van-form @submit="onSubmit" :label-width="60">
      <van-field
        readonly
        :clickable="!detail.plate_number"
        name="plate_number"
        :value="detail.plate_number"
        label="车牌号"
        placeholder="点击输入车牌号"
        @click="showInputCar = true"
        :disabled="!!detail.plate_number"
      />
      <div v-show="showCarDetail">
        <van-field
          v-model="detail.total_number"
          name="total_number"
          type="digit"
          label="总人数"
          placeholder="填写总人数"
          :rules="[{ required: true, message: '请填写总人数' }]"
        />
        <van-field
          v-model="detail.invalid_number_artificial"
          name="invalid_number_artificial"
          type="digit"
          label="手输无效"
          placeholder="填写手输无效人数"
          :rules="[{ required: true, message: '请填写手输无效人数' }]"
        />
        <!-- 手输有效=总人数-手输无效-扫描人数 -->
        <van-field
          :value="
            detail.total_number -
            detail.invalid_number_artificial -
            detail.effective_number_certificate -
            detail.invalid_number_certificate
          "
          name="effective_number_artificial"
          label="手输有效"
          placeholder="填写手输有效人数"
          disabled
        />
        <!-- 扫描人数=证件有效+证件无效 -->
        <van-field
          :value="
            Number(detail.effective_number_certificate) +
            Number(detail.invalid_number_certificate)
          "
          name="effective_number_certificate"
          label="扫描人数"
          placeholder="填写扫描人数"
          disabled
        />
      </div>

      <div style="margin: 20px">
        <van-button
          round
          block
          type="info"
          native-type="onSubmit"
          :disabled="!showCarDetail"
        >
          确认
        </van-button>
      </div>
    </van-form>

    <van-popup v-model="showInputCar" round position="bottom">
      <div style="padding: 20px">
        <vue-vehicle-plate @confirm="submit"></vue-vehicle-plate>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Form, Field, Popup, Button, Toast, Dialog } from "vant";
import Vue from "vue";
import VueVehiclePlate from "vue-vehicle-plate";
Vue.use(VueVehiclePlate);

export default {
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanButton: Button,
  },
  data() {
    return {
      domianId: this.$store.getters.USER.domain,
      showInputCar: false,
      detail: {},
      showCarDetail: false,
    };
  },
  methods: {
    checkFormat(str) {
      return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(
        str
      );
    },
    onSubmit() {
      Dialog.confirm({
        title: "车牌号：" + this.detail.plate_number,
        message: "确认核验这辆车吗？",
      })
        .then(() => {
          this.http.put(
            this.ports.business.validUpload(this.domianId, this.detail.id),
            {
              total_number: this.detail.total_number,
              invalid_number_artificial: this.detail.invalid_number_artificial,
              effective_number_artificial:
                this.detail.total_number -
                this.detail.invalid_number_artificial -
                this.detail.effective_number_certificate -
                this.detail.invalid_number_certificate,
              effective_number_certificate:
                this.detail.effective_number_certificate,
              invalid_number_certificate:
                this.detail.invalid_number_certificate,
            },
            (res) => {
              console.log(res);
              Toast.success("核验成功");
              this.$router.replace({
                path: "/",
              });
            },
            (err) => {
              console.log(err);
              Toast.fail(err.message);
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    //最近同步且未办理的接待记录
    submit(value) {
      if (!this.checkFormat(value.plateNum)) {
        Toast.fail("请输入正确的车牌号码");
        return;
      }
      console.log(value);

      this.http.get(
        this.ports.business.getBusData(this.domianId),
        {
          plateNumber: value.plateNum,
        },
        (res) => {
          if (res) {
            console.log(res, "有最近同步且未办理的接待记录");
            this.showInputCar = false;
            this.showCarDetail = true;
            this.detail = res;
          } else {
            Toast.fail("请输入正确的车牌号码");
          }
        },
        (err) => {
          console.log(err);
          Toast.fail("请输入正确的车牌号码");
        }
      );
    },
  },
};
</script>
